import React, { ReactNode } from 'react';
import { CheckIcon } from 'lucide-react';
interface FormSuccessProps {
  title: string;
  children: ReactNode;
  tone?: 'light' | 'dark';
}
export function FormSuccess({
  title,
  children,
  tone = 'light'
}: FormSuccessProps) {
  return <div role="status" aria-live="polite" className="flex items-start gap-4" data-id="element-74" data-mp="3268gan2mjpmm">
      <span className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-afb-turquoise text-afb-ink" data-id="element-75" data-mp="377fp8pgi6uuv">
        <CheckIcon aria-hidden="true" className="h-5 w-5" data-id="element-76" data-mp="3c3mt8cpc9wa6" />
      </span>
      <div data-id="element-77" data-mp="3h3iw28mavho5">
        <p className={`font-sora text-lg font-semibold ${tone === 'light' ? 'text-afb-ink' : 'text-white'}`} data-id="element-78" data-mp="3h2zguzo1b7dt">
          {title}
        </p>
        <div className={`mt-1 text-[15px] leading-relaxed ${tone === 'light' ? 'text-afb-muted' : 'text-white/70'}`} data-id="element-79" data-mp="3pwvyc1697vmw">
          {children}
        </div>
      </div>
    </div>;
}